import { useCookieConsent } from '@xhubio-saas/core-frontend/kernel'
import { Button, Card, CardContent } from '@xhubio-saas/core-frontend/ui-components'
import { CookieIcon } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { SettingsLayout } from '../../../layouts/SettingsLayout'

/**
 * Cookie settings — a tab in the settings navigation (`/settings/cookies`).
 * Relocated from a button in the "Rechtliches" card on Settings → System.
 *
 * The actual UI is the kernel's CookieSettings dialog (rendered by the
 * layout's CookieBanner); this page opens it on arrival and stays behind it
 * as a landing spot with a re-open button once the dialog is closed. All
 * copy comes from the kernel's `cookieConsent.*` bundle (13 languages) — no
 * app-local keys needed.
 */
export function CookieSettingsPage() {
  const { t } = useTranslation()
  const { openSettings } = useCookieConsent()

  // Open the dialog once per visit — not on every re-render, or closing it
  // would fight the effect.
  const openedOnArrival = useRef(false)
  useEffect(() => {
    if (!openedOnArrival.current) {
      openedOnArrival.current = true
      openSettings()
    }
  }, [openSettings])

  return (
    <SettingsLayout>
      <div data-testid="cookie-settings-page">
        <Card className="w-full max-w-md">
          <CardContent className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
              {t('cookieConsent.settings.description', 'Manage your cookie preferences')}
            </p>
            <div className="flex justify-end">
              <Button onClick={openSettings} data-testid="cookie-settings-open">
                <CookieIcon className="mr-1 h-4 w-4" />
                {t('cookieConsent.footer.cookieSettings', 'Cookie Settings')}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </SettingsLayout>
  )
}
